import { ROUTE_PATHS } from 'src/routes/_shared/routes.constants';
import { TProjectOptions } from '../projectOptions.types';

const EXT_ROUTES = [ROUTE_PATHS.UPLOAD_FAMILY_FRIENDS, ROUTE_PATHS.UPLOAD_SMARTPHONE, ROUTE_PATHS.GOOGLE_LOGIN];
/**
 * Updates the current URL with the new project options.
 * @param {TProjectOptions} projectOptions - The new project options to update the URL with.
 */
export function updateProjectOptions(projectOptions: TProjectOptions) {
  if (projectOptions.projectId) {
    const url = new URL(window.location.href);
    const route = url.pathname.replace('/', '') as ROUTE_PATHS;
    url.searchParams.set('projectId', projectOptions.projectId);
    if (!EXT_ROUTES.includes(route) && projectOptions.productConfigurationId) {
      url.searchParams.set('productConfigurationId', projectOptions.productConfigurationId);
    }
    //url.searchParams.set('productFamily', projectOptions.productFamily);
    if (projectOptions.groupCode) {
      url.searchParams.set('groupCode', projectOptions.groupCode);
    }
    history.pushState(null, '', url);
  }
}
